import { render, staticRenderFns } from "./services-agreements.vue?vue&type=template&id=859655a2&scoped=true"
import script from "./services-agreements.vue?vue&type=script&lang=js"
export * from "./services-agreements.vue?vue&type=script&lang=js"
import style0 from "./services-agreements.vue?vue&type=style&index=0&id=859655a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "859655a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('859655a2')) {
      api.createRecord('859655a2', component.options)
    } else {
      api.reload('859655a2', component.options)
    }
    module.hot.accept("./services-agreements.vue?vue&type=template&id=859655a2&scoped=true", function () {
      api.rerender('859655a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/register/services-agreements.vue"
export default component.exports